import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CameraWaste } from '@classes/waste-camera/waste-camera';



@Injectable({
    providedIn: 'root'
})
export class CameraWasteService {

    waste: CameraWaste[] = [
        {
            camera: "camera 1",
            batterie: "98%",
            infraction: 4,
            application: "SmartWaste"
        },
        {
            camera: "camera 2",
            batterie: "57%",
            infraction: 1,
            application: "SmartWaste"
        },
        {
            camera: "camera 3",
            batterie: "16%",
            infraction: 8,
            application: "SmartWaste"
        },
        {
            camera: "camera 4",
            batterie: "86%",
            infraction: 7,
            application: "SmartWaste"
        },
    ]




    constructor(

        private http: HttpClient

    ) { }
}
